// extracted by mini-css-extract-plugin
module.exports = {"container":"Review_container__2r9m8","split":"Review_split__3Zd2B","quantityDisplay":"Review_quantityDisplay__2p6lk","customerInfo":"Review_customerInfo__1513G"};